// extracted by mini-css-extract-plugin
export default {"top":"index_top_0O3Ts","video":"index_video_8NTuj"};